import {
  BorderColor,
  Cancel,
  Description,
  MonetizationOn,
  RemoveShoppingCart,
  Save,
  Search,
  ShoppingCart,
  Store,
  Visibility,
} from "@mui/icons-material";
import { Box, Chip, Grid, TextField, Typography } from "@mui/material";
import { render } from "@testing-library/react";
import PawnCarService from "_api/Car/pawnCar";
import useApi from "_api/index";
import Actions from "components/Car/Actions";
import TableData from "components/Car/Table";
import CustomizeDatePicker from "components/DatePicker";
import {
  GradientButton,
  GradientButtonOutline,
} from "components/GradientButton";
import ModalCarMarketPlace from "components/Modal/Car/ModalCarMarketPlace";
import ModalDetailCar from "components/Modal/Car/ModalDetailCar";
import ModalSellCar from "components/Modal/Car/ModalSellCar";
import ModalSettingPrice from "components/Modal/Car/ModalSettingPrice";
import ModalConfirm from "components/Modal/ModalConfirm";
import CustomPagination from "components/TableExplanded/Pagination";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatCurrency2Digit, formatDateTime } from "utils/helpers/format";

const ReadyCarsForSale = () => {
  const navigate = useNavigate();
  const [readyCarsList, setReadyCarsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({
    searchCode: "",
    searchLicensePlate: "",
    searchPrice: "",
    searchDate: "",
  });
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 1,
  });
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [isSellModalOpen, setIsSellModalOpen] = useState(false);
  const [isMarketPlaceModalOpen, setIsMarketPlaceModalOpen] = useState(false);
  const [isSettingPriceModalOpen, setIsSettingPriceModalOpen] = useState(false);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  useEffect(() => {
    // This effect runs when the component mounts
    fetchData();
  }, [pagination.page, pagination.limit]);

  const fetchData = async (isClear = false) => {
    setLoading(true);
    await useApi.ready_car
      .getReadySellCarList({
        page: pagination.page || 1,
        limit: pagination.limit || 10,
        ...(isClear ? {} : filter),
      })
      .then((response) => {
        console.log("Fetched ready cars for sale:", response);
        if (response.success) {
          setReadyCarsList(response.data || []);
          setPagination((prev) => ({
            ...prev,
            total: response.meta.total || 0,
            totalPages: response.meta.totalPages || 1,
          }));
        }
      })
      .catch((error) => {
        console.error("Error fetching ready cars for sale:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handlePageChange = (event, value) => {
    setPagination((prev) => ({
      ...prev,
      page: value + 1,
    }));
    // fetchData();
  };

  const handleRowsPerPageChange = (event) => {
    setPagination((prev) => ({
      ...prev,
      limit: event.target.value,
      page: 1, // Reset to first page when changing rows per page
    }));
    // fetchData();
  };

  const handleCancelReserveCarForSell = async () => {
    try {
      if (!selectedRow) return;
      const response = await useApi.ready_car.cancelSellCarOrder(
        selectedRow.car_id
      );
      console.log("Response from canceling reserve:", response);
      if (response.success) {
        setIsCancelModalOpen(false);
        setSelectedRow(null);
        fetchData();
      }
    } catch (error) {
      console.error("Error canceling reserve:", error);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography component={"div"} sx={{ fontSize: "32px" }}>
          รถพร้อมขาย
        </Typography>
        <GradientButtonOutline
          onClick={() => {
            // Handle create new car action
            console.log("Create new car action triggered");
          }}
          sx={{
            px: 3,
            height: "48px",
            bgcolor: "white",
          }}
          endIcon={<Save fontSize="medium" />}
        >
          <Typography>ส่งออก Excel</Typography>
        </GradientButtonOutline>
      </Box>

      <Box
        sx={{
          mb: 2,
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={3}>
            <Grid container spacing={2} alignItems="center">
              <Grid
                item
                xs={3}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Typography>รหัสรถ</Typography>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  value={filter.searchCode}
                  onChange={(e) =>
                    setFilter((prev) => ({
                      ...prev,
                      searchCode: e.target.value,
                    }))
                  }
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "white",
                      height: "40px",
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <Grid container spacing={2} alignItems="center">
              <Grid
                item
                xs={3}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Typography>ทะเบียน</Typography>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  value={filter.searchLicensePlate}
                  onChange={(e) =>
                    setFilter((prev) => ({
                      ...prev,
                      searchLicensePlate: e.target.value,
                    }))
                  }
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "white",
                      height: "40px",
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <Grid container spacing={2} alignItems="center">
              <Grid
                item
                xs={3}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Typography>ราคา</Typography>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  value={filter.searchPrice}
                  onChange={(e) =>
                    setFilter((prev) => ({
                      ...prev,
                      searchPrice: e.target.value,
                    }))
                  }
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "white",
                      height: "40px",
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <Grid container spacing={2} alignItems="center">
              <Grid
                item
                xs={3}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Typography>วันที่ซื้อเข้า</Typography>
              </Grid>
              <Grid item xs={9}>
                <CustomizeDatePicker
                  value={filter.searchDate}
                  onChange={(newValue) => {
                    setFilter((prev) => ({
                      ...prev,
                      searchDate: newValue,
                    }));
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            mt: 2,
          }}
        >
          <GradientButtonOutline
            onClick={() => {
              setFilter({
                searchCode: "",
                searchLicensePlate: "",
                searchPrice: "",
                searchDate: "",
              });
              setPagination((prev) => ({
                ...prev,
                page: 1,
              }));
              fetchData(true);
            }}
            sx={{
              px: 3,
              height: "40px",
              bgcolor: "white",
            }}
          >
            <Typography>ล้าง</Typography>
          </GradientButtonOutline>
          <GradientButton
            onClick={() => {
              setPagination((prev) => ({
                ...prev,
                page: 1,
              }));
            }}
            sx={{
              px: 3,
              height: "40px",
              ml: 2,
            }}
            endIcon={<Search fontSize="medium" />}
          >
            <Typography>ค้นหา</Typography>
          </GradientButton>
        </Box>
      </Box>

      <TableData
        loading={loading}
        columns={[
          { key: "expand", label: "" },
          {
            key: "car_pictures",
            label: "รูปภาพ",
          },
          { key: "car_code", label: "รหัสรถ" },
          { key: "license_plate", label: "ทะเบียน" },
          { key: "car_brand", label: "ยี่ห้อ" },
          {
            key: "car_price",
            label: "ราคาทุน",
            render: (row) => formatCurrency2Digit(row.car_price),
          },
          {
            key: "sell_pricee",
            label: "ราคาขาย",
            render: (row) =>
              row.sell_price === null ? (
                "-"
              ) : (
                <Typography sx={{ color: "green" }}>
                  {formatCurrency2Digit(row.sell_price)}
                </Typography>
              ),
          },
          {
            key: "created_at",
            label: "วันที่ซื้อเข้า",
            render: (row) => formatDateTime(row.created_at),
          },
          {
            key: "car_product_type",
            label: "ประเภท",
            render: (row) => {
              return row.car_product_type === "pawn_car" ? (
                <Chip label="หลุดจำนำ" color="error" size="md" />
              ) : row.car_product_type === "buy_car" ? (
                <Chip label="รถที่ซื้อ" color="primary" size="md" />
              ) : row.car_product_type === "consignment_car" ? (
                <Chip
                  label="รถฝากขาย"
                  size="md"
                  sx={{
                    bgcolor: "#663C00",
                    color: "white",
                  }}
                />
              ) : (
                <Chip label="ไม่ระบุ" color="default" size="md" />
              );
            },
          },
          {
            key: "is_reserved",
            label: "สถานะ",
            render: (row) => {
              return (
                <Chip
                  label={row.is_reserved ? "ติดจอง" : "พร้อมขาย"}
                  color={row.is_reserved ? "error" : "success"}
                  size="md"
                />
              );
            },
          },
          {
            key: "market_status",
            label: "MarketPlace",
            render: (row) => {
              return row.marketplace_car_status ? (
                <Chip label="วางขายแล้ว" color="success" size="md" />
              ) : (
                <Chip label="ยังไม่วางขาย" color="error" size="md" />
              );
            },
          },
          {
            key: "action",
            label: "Actions",
            style: {
              textAlign: "center",
            },
            render: (row) => {
              return (
                <Actions
                  menuList={[
                    {
                      label: "ดูรายละเอียด",
                      icon: <Visibility />,
                      onClick: () => {
                        console.log("Edit clicked for row:", row);
                        setSelectedRow(row);
                        setIsDetailModalOpen(true);
                      },
                    },
                    ...(row.is_reserved
                      ? [
                          {
                            label: "ยกเลิกขาย",
                            icon: <RemoveShoppingCart />,
                            onClick: () => {
                              console.log(
                                "Edit action triggered for row:",
                                row
                              );
                              // Handle edit action
                              setSelectedRow(row);
                              setIsCancelModalOpen(true);
                              //open modal cancel sell
                            },
                          },
                        ]
                      : [
                          {
                            label: "ขาย",
                            icon: <ShoppingCart />,
                            onClick: () => {
                              console.log(
                                "Edit action triggered for row:",
                                row
                              );
                              // Handle edit action
                              setSelectedRow(row);
                              setIsSellModalOpen(true);
                            },
                          },
                          {
                            label: "ตั้งราคาขาย",
                            icon: <MonetizationOn />,
                            onClick: () => {
                              setSelectedRow(row);
                              setIsSettingPriceModalOpen(true);
                            },
                          },
                        ]),
                    {
                      label: "MarketPlace",
                      icon: <Store />,
                      onClick: () => {
                        console.log(
                          "MarketPlace action triggered for row:",
                          row
                        );
                        setSelectedRow(row);
                        setIsMarketPlaceModalOpen(true);
                        // Handle marketplace action
                      },
                    },
                    ...(!row.is_reserved
                      ? []
                      : [
                          {
                            label: "ฟอร์มเอกสาร",
                            icon: <Description />,
                            onClick: () => {
                              navigate(`/car/ready_cars/form/${row.car_id}`);
                            },
                          },
                        ]),
                  ]}
                />
              );
            },
          },
        ]}
        data={readyCarsList}
      />

      <CustomPagination
        totalPage={pagination.totalPages}
        page={pagination.page - 1} // Convert to 0-based index
        rowsPerPage={pagination.limit}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      <ModalDetailCar
        open={isDetailModalOpen}
        onClose={() => {
          setIsDetailModalOpen(false);
          setSelectedRow(null);
        }}
        rowID={selectedRow ? selectedRow.car_id : null}
        type="ready_car"
        formlist={[
          {
            id: 1,
            document: "แบบคำขอโอนและรับโอน",
            document_type: "car_transform",
          },
          {
            id: 2,
            document: "หนังสือมอบอำนาจ",
            document_type: "car_power_of_attorney",
          },
          {
            id: 3,
            document: "หนังสือสัญญาซื้อ - ขายรถ",
            document_type: "car_sell_contact",
          },
        ]}
      />

      <ModalSellCar
        open={isSellModalOpen}
        onClose={() => {
          setIsSellModalOpen(false);
          setSelectedRow(null);
        }}
        onSaved={() => {
          setIsSellModalOpen(false);
          setSelectedRow(null);
          fetchData();
        }}
        id={selectedRow ? selectedRow.car_id : null}
      />

      <ModalCarMarketPlace
        open={isMarketPlaceModalOpen}
        onClose={() => {
          setIsMarketPlaceModalOpen(false);
          setSelectedRow(null);
          fetchData();
        }}
        id={selectedRow ? selectedRow.car_id : null}
      />

      <ModalSettingPrice
        open={isSettingPriceModalOpen}
        onClose={() => {
          setIsSettingPriceModalOpen(false);
          setSelectedRow(null);
        }}
        car={selectedRow ? selectedRow : null}
        onSuccess={() => {
          setIsSettingPriceModalOpen(false);
          setSelectedRow(null);
          fetchData();
        }}
      />

      <ModalConfirm
        open={isCancelModalOpen}
        onClose={() => {
          setIsCancelModalOpen(false);
          setSelectedRow(null);
        }}
        onConfirm={handleCancelReserveCarForSell}
        title="ยืนยันยกเลิกการขายรถ"
        message="คุณต้องการยกเลิกการขายรถคันนี้ใช่หรือไม่?"
        type="confirm"
      />
    </Box>
  );
};
export default ReadyCarsForSale;
